<template>
  <div class="header-sub-nav-checkbox-wrap">
    <label class="light-label checkbox-wrap">
      Display Plans Info in Each Block
      <input
        type="checkbox"
        @input="changePlanDesignsMinimizedState"
        :checked="showPlanDesignsMiniTable"
      />
      <div class="checkbox">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          id="prefix__checkbox_selected"
          width="16"
          height="16"
          viewBox="0 0 16 16"
        >
          <path
            d="M1704.086 777.084l-1.586-1.584 1.414-1.415 1.586 1.586 4.586-4.587 1.414 1.415-4.586 4.586-1.414 1.415z"
            transform="translate(-1699 -767)"
            style="fill:#fff"
          />
        </svg>
      </div>
    </label>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { PLAN_DESIGN_FIELDS_CHANGE_STATE } from "@/store/mutations.type";
export default {
  name: "RoePlanDesignsMinimizedCheckbox",
  computed: {
    ...mapGetters(["showPlanDesignsMiniTable"])
  },
  methods: {
    ...mapMutations({
      changePlanDesignsMinimizedState: PLAN_DESIGN_FIELDS_CHANGE_STATE
    })
  }
};
</script>
